import { DeleteOutlined } from "@ant-design/icons";
import React from "react";
import { images } from "../../assets";
import { priceFormat } from "../../utils";
import InputNumberCart from "../InputNumberCart";
import { useDispatch, useSelector } from "react-redux";
import { updateNumber, deleteItem } from "../../app/features/cart";
import { store } from "../../app/store";
import SImage from "../SImage";

const CartItem = ({ data, action }) => {
  const dispatch = useDispatch();
  const onChangeNumber = (value) => {
    store.dispatch((dispatch, getState) =>
      updateNumber(dispatch, getState, {
        quantity: value,
        unit_id: data.unit_id,
        drug_id: data.drug_id,
      })
    );
  };

  const onDeleteItem = () => {
    store.dispatch((dispatch, getState) =>
      deleteItem(dispatch, getState, {
        unit_id: data.unit_id,
        drug_id: data.drug_id,
      })
    );
  };
  const Time = (time) => {
    if (time <= 24) {
      return time + " Giờ Làm Việc";
    } else if (time % 24 === 0) {
      return Math.floor(time / 24) + " Ngày Làm Việc";
    } else {
      return Math.floor(time / 24) + " Ngày " + (time % 24) + " Giờ Làm Việc";
    }
  };
  return (
    <div className="flex relative flex-row h-[112px]">
      <div className="w-[112px] h-[112px] bg-[#F9F9F9] rounded-xl mr-6">
        <SImage
          src={data.image}
          className="object-cover w-full h-full"
          alt=""
        />
      </div>
      <div className="flex items-center justify-between flex-1">
        <div className="flex flex-col justify-between h-full">
          <div className=" sm:w-[230px]">
            <p className="sm:text-sm text-[12px]  font-bold text-[#222222] not-italic capitalize">
              {data.drug_name}
            </p>
            <p className="font-normal text-two-lines text-[#222222] sm:text-sm text-[10px] not-italic capitalize">
              {data.category_name}
            </p>
          </div>
          <div>
            {action ? (
              <div className="block sm:hidden">
                <InputNumberCart
                  onChange={onChangeNumber}
                  value={data.quantity}
                />
              </div>
            ) : (
              <p className="text-base font-normal text-[#222222] not-italic lowercase">
                x{data.quantity}
              </p>
            )}
            {data.time_delivery && (
              <span className="font-normal sm:text-sm text-[8px] text-[#08AF37] not-italic leading-[8px]">
                {Time(data.time_delivery)}
              </span>
            )}
          </div>
        </div>
        {action ? (
          <div className="hidden sm:block">
            <InputNumberCart onChange={onChangeNumber} value={data.quantity} />
          </div>
        ) : (
          <p className="text-base font-normal text-[#222222] not-italic lowercase">
            x{data.quantity}
          </p>
        )}

        <div className="flex flex-col ">
          {" "}
          <p className="font-bold text-end sm:static absolute top-16 right-0 sm:text-lg text-xs	text-[#2297D4] not-italic sm:min-w-[100px]">
            {priceFormat(data.out_price)}/{data.unit_name}
          </p>
          <p className="font-bold text-end sm:static absolute top-16 right-0 sm:text-lg text-xs	text-[#2297D4] not-italic sm:min-w-[100px]">
            {priceFormat(data.out_price * data.quantity)}
          </p>
        </div>
      </div>
      {action && (
        <button
          className="flex justify-center items-center absolute bottom-0 right-0 text-lg text-[#979797]"
          onClick={onDeleteItem}
        >
          <DeleteOutlined />
        </button>
      )}
    </div>
  );
};

export default CartItem;
